import React, { memo } from "react";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "./HeaderMenu.css";
import userIcon from "Assets/user-profile.png";


import logo from "Assets/postcast-logo.png";

const HeaderMenu = (props) => {
  const {
    onClickInstructions,
    onClickHamburgerMenu,
    encourageClue,
    dontShowClue,
  } = props;
  const userEmail = useSelector((state) => state.clientProfileSlice.profile?.email);
  const navigate = useNavigate();
  const clueContainerClassname = `newsie-header-clue-button-container ${
    encourageClue ? "strobe" : ""
  } ${dontShowClue ? "no-clue" : ""}`;
  return (
    <div className="header-container">
      <div className="newsie-menu-icon-container">
        <img src={logo} style={{ width: 60, height: 60}} />
        <div
          className="unauthed-header-title-text"
          onClick={() => navigate("/")}
        >
          Postcast.io
        </div>
      </div>
      {/* Todo: Add Org */}
      <div className='header-menu-buttons-container'>
        <div
          onClick={onClickHamburgerMenu}
          className="client-user-menu-container"
        >
          <img
            src={userIcon}
            style={{ height: 15, width: 15 , marginRight:5}}
            alt="website logo"
            className="profile-button-icon"
          />
          <div className="client-portal-user-name-text">
            {userEmail}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(HeaderMenu);
